import { render } from "./OverTimeComponent.vue?vue&type=template&id=2da84fee&ts=true"
import script from "./OverTimeComponent.vue?vue&type=script&lang=ts"
export * from "./OverTimeComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__